import { useState, useEffect } from 'react';

export const useSettings = config => {
    const [settings, setSettings] = useState({ ...config.defaultSettings, ...config.settings });
    useEffect(() => {
        setSettings({ ...config.defaultSettings, ...config.settings });
    }, [config]);
    return settings;
};
